import { css, cva } from '@/styled-system/css';

export const buttonEditStyles = cva({
  base: {
    cursor: 'pointer',
    marginLeft: '4px',
  },
  variants: {
    disabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 0.5,
        color: 'text.neutral',
      },
    },
  },
});

export const styledRequestNotificationSpanStyles = css({
  backgroundColor: 'bg.critical',
  borderRadius: '50%',
  color: 'text.inverse',
  fontWeight: 'bold',
  lineHeight: '20px',
  marginLeft: '200',
  height: '20px',
  width: '20px',
});

export const styledTabCountSpanStyles = css({
  border: '1px solid',
  borderRadius: '10px',
  padding: '2px 10px',
  marginLeft: '4px',
});

export const styledUserManagementPageStyles = css({
  '&-container': {
    mdDown: {
      padding: 0,
      maxWidth: '100%',
    },
  },
  '&-card': {
    marginBottom: '65px',
    padding: '0 8px 8px 8px',
    md: {
      padding: '0 16px 16px 16px',
      marginTop: '20px',
    },
  },
  '&-SubNav': {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'bg.neutral.base',
    padding: 0,
    margin: 0,
    maxWidth: 'inherit',
  },
  '& .UsersPage-add-button': {
    textAlign: 'right',
  },
  '& .full-width': {
    width: '100%',
  },
  '& .UsersPage-SubNav': {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'bg.neutral.base',
    padding: 0,
    margin: 0,
    maxWidth: 'inherit',
  },
  '& .UsersPage-SubNav-list': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  '& .Badge': {
    marginLeft: '8px',
  },
  '& .UsersPage-add-user-icon': {
    marginRight: '8px',
  },
  '& .empty-message': {
    textAlign: 'center',
    padding: '30px 0',
  },
  '& .edit-company-name-wrapper': {
    position: 'relative',
  },
  '& .close-edit-company-name-icon': {
    position: 'absolute',
    top: '14px',
    right: '17px',
    cursor: 'pointer',
  },
});
